module.exports = __webpack_public_path__ + "images/0368c5de.www_11_chs.png";


//////////////////
// WEBPACK FOOTER
// ./images/baseintro/www_11_chs.png
// module id = 467
// module chunks = 0